import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import {environment} from 'src/environments/environment';
import {ApplicationLogDetailsRequest, ApplicationLogStepRequest, Log, Step} from "leia-api";
import NameEnum = Step.NameEnum;
import StateEnum = Step.StateEnum;
import OnboardingSourceEnum = ApplicationLogDetailsRequest.OnboardingSourceEnum;
import OnboardingStepEnum = ApplicationLogStepRequest.OnboardingStepEnum;
import OnboardingStateEnum = ApplicationLogStepRequest.OnboardingStateEnum;

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {
  static deviceRiskSessionId : string = "";

  constructor(
    private logger: NGXLogger
  ) { }

  /**
   * Replace n number of values in a given string.
   * @param inString String needing replacement values.
   * @param replaceVals Key-value pairs of replacement strings and their values.
   */
  replaceStringContent(inString: string, replaceVals: Map<string, string>): string {
    let outString: string = inString;

    if (!environment.production){
        this.logger.debug("**********************\n");
        this.logger.debug("replacement string = " + inString);
    }

    replaceVals.forEach((value: string, key: string) => {
        var escapedFind = key.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        outString = outString.replace(new RegExp(escapedFind, 'gi'), value);
        if (!environment.production){
          this.logger.debug("key = " + key);
          this.logger.debug("value = " + value);
          this.logger.debug("outString = " + outString);
        }
    });

    return outString;
  }

  /**
   * Utility method for cloning an object. Refactored out of signup.service.ts in PR !13437.
   * @param inObject The object to be cloned.
   */
  cloneObject(inObject: any): any {
    return Object.assign({}, inObject);
  }

  /**
   * Utility method for creating an application Log.
   * @param source
   * @param details
   */
  createLog(source: string, details: string): Log {
    let log = new Log();
    log.source = source;
    log.timestamp = new Date();
    log.details = details;
    return log;
  }

  /**
   * Utility method for creating an application Log.
   * @param source
   * @param details
   */
  createStep(name: NameEnum, state: StateEnum, logs: Log[]): Step {
    let step = new Step();

    step.name = name;
    step.state = state;
    step.timestamp = new Date();
    step.logs = logs;

    return step;
  }

  createApplicantStep(name: NameEnum, applicantId : number, state: StateEnum, logs: Log[]): Step {
    let step = this.createStep(name, state, logs);
    step.applicantId = applicantId;

    return step;
  }

  /**
   * Utility method for creating an application Log.
   * @param source
   * @param details
   */
  createEmptyStepForLogging(logs: Log[]): Step {
    let step = new Step();

    step.timestamp = new Date();
    step.logs = logs;

    return step;
  }

  scrollToElement(elementId: string): void {
    document.getElementById(elementId)?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }

  createApplicationLogDetailsRequest(source : OnboardingSourceEnum, details: string) : ApplicationLogDetailsRequest {
    let applicationLogDetailsRequest = new ApplicationLogDetailsRequest();

    applicationLogDetailsRequest.onboardingSource = source;
    applicationLogDetailsRequest.details = details;

    return applicationLogDetailsRequest;
  }
  createApplicationLogStepRequest(step : OnboardingStepEnum, state : OnboardingStateEnum, source : OnboardingSourceEnum, logs : ApplicationLogStepRequest[]) : ApplicationLogStepRequest {
    let applicationLogStepRequest = new ApplicationLogStepRequest();

    applicationLogStepRequest.onboardingStep = step;
    applicationLogStepRequest.onboardingSource = source;
    applicationLogStepRequest.onboardingState = state;
    applicationLogStepRequest.applicationLogDetailsRequestList = logs;

    return applicationLogStepRequest;
  }

  createEntireApplicationLogStepRequest(step : OnboardingStepEnum, state : OnboardingStateEnum, source : OnboardingSourceEnum, applicantId : number, rcCode : string | undefined, logs : ApplicationLogStepRequest[]) : ApplicationLogStepRequest {
    let applicationLogStepRequest = new ApplicationLogStepRequest();

    applicationLogStepRequest.onboardingStep = step;
    applicationLogStepRequest.onboardingSource = source;
    applicationLogStepRequest.onboardingState = state;
    applicationLogStepRequest.applicationLogDetailsRequestList = logs;

    if(applicantId !== undefined && applicantId !== null) applicationLogStepRequest.applicantId = applicantId;
    if(rcCode !== undefined && rcCode !== null) applicationLogStepRequest.rcCode = rcCode;

    return applicationLogStepRequest;
  }

  //To restrict user to enter alphabets.
  //check if entered value is number or not.
  isNumberOnly(event: any) {
    if ((event.keyCode < 48 || event.keyCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
}

export function getEmptyStringIfNull(value: any): string {
  if (value === null || value === undefined) {
    return "";
  }

  return value;
}

export class ValidArray<T> {
  private _array: Array<T> = [];

  constructor(array: Array<T>) {
    if (Array.isArray(array)) {
      this._array = array;
    }
  }

  first(): T | undefined{
    if (this._array[0]) {
      return this._array[0]
    }

    return undefined;
  }

  hasValues(): boolean {
    return this._array.length > 0;
  }

  value(): Array<any> {
    return this._array;
  }
}
